import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { IResponse } from '../models';
import { IEmployee, IEmployeeDetail, IEmployeeDetailPayload, ILookupType } from '../models/employee';

const baseUrl = '/api/Admin/Employee';

export const EmployeesAPI = {
  async fetchListOfEmployees(filters?: {
    page?: number;
    perPage?: number;
    sortBy?: string;
    sortDirection?: string;
    sort?: string;
    Name?: string;
    Role?: string;
    IsActive?: boolean;
  }): Promise<IResponse<IEmployee[]>> {
    try {
      const response: AxiosResponse<IResponse<IEmployee[]>> = await authFetch.get(`${baseUrl}/list`, filters);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchEmployee(employeeId: string): Promise<IEmployeeDetail> {
    try {
      const response: AxiosResponse<IEmployeeDetail> = await authFetch.get(`${baseUrl}/${employeeId}`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async updateEmployee(employeeId: string, employee: IEmployeeDetailPayload): Promise<IEmployeeDetail> {
    try {
      const response: AxiosResponse<IEmployeeDetail> = await authFetch.put(`${baseUrl}/${employeeId}`, employee);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchRoles(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/roles`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchSubsidiaries(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/subsidiaries`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchOffices(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/offices`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchActivityTypes(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/activity-types`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchProductSpecialties(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/product-specialties`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchTeams(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/teams`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchAssistants(excludeEmployeeId?: string): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(
        `${baseUrl}/drop-down-data`,
        { params: { employeeRoleFilter: 'Assistant', excludeEmployeeId } }
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchTeamAdmins(excludeEmployeeId?: string): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(
        `${baseUrl}/drop-down-data`,
        { params: { employeeRoleFilter: 'Producer', excludeEmployeeId } }
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchSupportStaff(excludeEmployeeId?: string): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(
        `${baseUrl}/drop-down-data`,
        { params: { employeeRoleFilter: 'SupportStaff', excludeEmployeeId } }
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchBusinessUnitTypes(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/business-unit-types`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchDepartments(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/departments`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async fetchProductTypes(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/product-types`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async postResetOverride(employeeId: string): Promise<any> {
    try {
      const response: AxiosResponse<any> = await authFetch.post(`${baseUrl}/${employeeId}/reset-override`, {});
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchSpecialtyTypes(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/specialty-types`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async fetchBankAccounts(): Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/bank-accounts`);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
